import type { Collection } from 'pkg/api/models/collection';

export function hasPrev<T>(collection: Collection<T>): boolean {
	return !!collection?.links && 'previous' in collection.links;
}

export function hasNext<T>(collection: Collection<T>): boolean {
	return !!collection?.links && 'next' in collection.links;
}
